module.exports = __webpack_public_path__ + "static/media/nursingliquid1.05a6f9eb.jpg";